module.exports = __webpack_public_path__ + "img/Reasonable-and-Detailed-Data-Dimensions.548fb4f0.png";